import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { GET_ALL_ORDERS } from '@common/src/lib/graphql/query/orders';
import OrderTable from './orderTable';
import Loader from '@common/src/common/loader/loader';
import PropTypes from 'prop-types';
import { ALL_OPTION } from '@pulse/constants/constants';
import { calcOffset } from '@common/src/common/helper';
import { useToast } from '@common/src/common/Toast/ToastProvider';
import { useSelector } from 'react-redux';
import { ALL_ORDERS_STATUS_LIST } from './common';


const AllOrders = ({ store }) => {
    const [allOrders, setAllOrders] = useState([]);
    const [filterStatus, setFilterStatus] = useState('');
    const [selectedFilterStatusValue, setSelectedFilterStatusValue] = useState(ALL_OPTION.status);
    const { stores = [] } = useSelector((state) => state.auth || {});
    const [filterStartDate, setFilterStartDate] = useState('');
    const [filterEndDate, setFilterEndDate] = useState('');
    const toast = useToast()

    const [pagination, setPagination] = useState({
        limit: 100,
        totalPages: 0,
        currentPage: 1,
        offset: 0,
        totalRecords: 0
    })
    const [searchQuery, setSearchQuery] = useState('');
        let storeIds = stores
        .map(store => (store.value).toString())
        .filter(id => !isNaN(id) && id !== undefined);
    const { data, loading, refetch, error } = useQuery(GET_ALL_ORDERS, {
        variables: {
            offset: calcOffset(searchQuery, pagination.currentPage, pagination.limit, pagination.totalRecords),
            limit: pagination.limit,
            search: searchQuery || undefined,
            storeId: store?.value === ALL_OPTION.stores.value ? storeIds : [store.value.toString()],
            filters: {
                storeId: store?.value === ALL_OPTION.stores.value ? storeIds : [store.value.toString()],
                orderStatus: filterStatus || ALL_ORDERS_STATUS_LIST,
                startDate: filterStartDate || undefined,
                endDate: filterEndDate || undefined
            }
        },
        fetchPolicy: 'no-cache'
    });

    useEffect(() => {
        if (data && !loading && !error) {
            setAllOrders(data.orderListQuery.rows);
            setPagination((prevPagination) => ({
                ...prevPagination,
                totalPages: data.orderListQuery.totalPages,
                totalRecords: data.orderListQuery.totalRecords,
            }))
        } else {
            setAllOrders([])
        }
    }, [data, loading, error]);

    // Function to handle the search term
    const handleSearchChange = (newSearchItem) => {
        setSearchQuery(newSearchItem);
    };
    useEffect(() => {
        refetch({
            variables: {
                offset: calcOffset(searchQuery, pagination.currentPage, pagination.limit, pagination.totalRecords),
                limit: pagination.limit,
                ...(searchQuery && { search: searchQuery }),
                ...(store && { storeId: store?.value.toString() }),
            },
        });
        setPagination((prevPagination) => ({
            ...prevPagination,
            currentPage: 1
        }))
        onAllFilter('', '', ALL_OPTION.status); // Reset filters when search query changes
    }, [store, searchQuery]);

    const onAllFilter = (selectedStartDate, selectedEndDate, selectedStatus) => {

        if (selectedStartDate && !selectedEndDate) {
            toast.error('Please select the To date.')
            return;
        } else if (!selectedStartDate && selectedEndDate) {
            toast.error('Please select the From date.')
            return;
        }

        setFilterStatus('');
        setSelectedFilterStatusValue(ALL_OPTION.status);
        setFilterStartDate('');
        setFilterEndDate('');
        if (selectedStatus?.value) {
            setFilterStatus(selectedStatus?.value === 'all' ? '' : selectedStatus?.value)
            setSelectedFilterStatusValue(selectedStatus)
        }
        if (selectedStartDate !== '') {
            setFilterStartDate(selectedStartDate)
        }
        if (selectedEndDate !== '') {
            setFilterEndDate(selectedEndDate)
        }
    }

    if (loading) return <Loader />
    return (
        <div className="mt-6 table-responsive">
            <OrderTable
                onFilter={onAllFilter}
                orders={allOrders}
                searchQuery={handleSearchChange}
                searchData={searchQuery}
                selectedFilterStatus={selectedFilterStatusValue}
                filterStartDate={filterStartDate}
                pagination={pagination}
                filterEndDate={filterEndDate}
                setPagination={setPagination}
                loading={loading}
            />
        </div>
    )
}
AllOrders.propTypes = {
    store: PropTypes.object,
}
export default AllOrders;
